import Component from './Component';
import ComponentStyles from './Styles';

export const Styles = ComponentStyles;

export default Component;
